import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";
import {useTranslation} from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "../inputs/Button";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import MaterialLink from "@mui/material/Link";

const MailDialog = ({open, setOpen, mail}) => {
    const {t} = useTranslation();

    const handleClose = () => {
        setOpen(false);
    };


    if (!mail) return <></>;

    return (
        <Dialog
            open={open}
            aria-labelledby=''
            aria-describedby=''
            fullWidth
        >
            <DialogTitle id="mail-dialog-title">{mail.Subject}</DialogTitle>
            <DialogContent>
                <DialogContentText id="mail-dialog-description">
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('tablecell_mail_part_number')}</TableCell>
                                    <TableCell>{t('tablecell_mail_link')}</TableCell>
                                </TableRow>
                            </TableHead>
                            {Object.keys(mail.Part).map(key =>
                                <TableRow>
                                    <TableCell>{key}</TableCell>
                                    <TableCell>
                                        <MaterialLink href={mail.Part[key].Url} target='_blank' rel="noopener noreferrer">
                                            {mail.Part[key].Filename === 'part' ? mail.Part[key].Mime : mail.Part[key].Filename}
                                        </MaterialLink>
                                    </TableCell>
                                </TableRow>)}
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {t('close_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MailDialog;